import Axios from 'axios'
import { createContext, useState, useContext, useEffect, useMemo } from 'react'
import { baseURL } from '../../../../services/api'

export const ContasReceberContext = createContext()

export const ContasReceberProvider = ({ children }) => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(1)
  const [lastPage, setLastPage] = useState(null)
  const [pendencia, setPendencia] = useState('A')
  const [empresa, setEmpresa] = useState('')
  const [dataFiltro, setDataFiltro] = useState({
    dataEntrada: '',
    dataSaida: '',
    numeroPedido: '',
    numeroNfe: '',
  })

  async function getInfoContasReceber(data) {
    setLoading(true)

    const params = {
      numero_pedido: data.numero_pedido,
      data_entrada: data.data_entrada,
      data_saida: data.data_saida,
      numero_nfe: data.numero_nfe,
      empresa: data.empresa,
      pendente: pendencia,
    }


    const response = await baseURL.post(
      `/pedido/lista-contas-recebecer?page=${page}`,
      params
    )

    if (pendencia === 'A') {
      const orderByOlder = response.data.data.sort((a, b) => {
        return new Date(a.data_vencimento) - new Date(b.data_vencimento)
      })

      setData(orderByOlder)
      setLoading(false)
      return
    }

    setData(response.data.data)
    setLastPage(response.data.last_page)
    setLoading(false)
  }


  useEffect(() => {
    getInfoContasReceber({
      numero_pedido: dataFiltro.numeroPedido,
      data_entrada: dataFiltro.dataEntrada,
      data_saida: dataFiltro.dataSaida,
      numero_nfe: dataFiltro.numeroNfe,
      empresa: empresa,
      pendente: pendencia,
    })

    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [page])

  return (
    <ContasReceberContext.Provider
      value={{
        data,
        setData,
        getInfoContasReceber,
        loading,
        setPage,
        page,
        lastPage,
        setPendencia,
        setEmpresa,
        setDataFiltro,
      }}
    >
      {children}
    </ContasReceberContext.Provider>
  )
}

export const useContasReceber = () => useContext(ContasReceberContext)
